import {
  getFiltersFailure,
  getFiltersPending,
  getFiltersSuccess,
  setActiveFilters,
  setFavoriteFilter,
} from '.'
import { request } from '../../../../common/utility/fetch'
import configuration from '../../../../configuration'
import { AppThunk } from '../../../store'
import { Tag } from '../onDemandWorkouts'
import { FiltersJsonResponse } from './filters'

const fetchFilters = async (): Promise<Tag[]> => {
  const baseUrl = configuration.onlinePlatformApi
  const endpoint = '/workout-library/tags'
  const method = 'GET'
  const response = await request({ baseUrl, endpoint, method })
  const { content, error }: FiltersJsonResponse = await response.json()
  return response.ok ? (content as Tag[]) : Promise.reject(new Error(error))
}

export const getFilters = (): AppThunk => async (dispatch) => {
  dispatch(getFiltersPending(true))
  try {
    const response = await fetchFilters()
    dispatch(getFiltersSuccess(response))
  } catch (error: any) {
    dispatch(getFiltersFailure(error.toString()))
  }
}

export const setFilters =
  (tagFilters: number[], hideCompleted: boolean): AppThunk =>
  (dispatch) => {
    dispatch(setActiveFilters({ tags: tagFilters, hideCompleted }))
  }

export const setFavorite =
  (filterState: boolean): AppThunk =>
  (dispatch) => {
    dispatch(setFavoriteFilter(filterState))
  }
